// @ts-check

/**
 * Something like jQuery' $.ready function.
 * @param {() => any} fn
 * @returns {any}
 */
export const ready = function (fn) {
  // Sanity check
  if (typeof fn !== 'function') {
    return;
  }

  // If document is already loaded, run method
  if (document.readyState === 'complete') {
    return fn();
  }

  // Otherwise, wait until document is loaded
  document.addEventListener('DOMContentLoaded', fn, false);
};

/**
 * Fjerner et element fra dom'en
 * @param {Element} el
 */
export const removeElement = (el) => {
  if (typeof el.remove !== 'undefined') {
    el.remove();
  } else {
    el.parentNode.removeChild(el);
  }
};
